import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "ng2-translate";
import {ToastsManager} from "ng2-toastr";
import {LandingpageResource, AppSettings} from "./landingpage.resource";

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.less']
})
export class LandingpageComponent implements OnInit {
  @ViewChild('languageSelector') langSelector: any;

  uploadsPath: string = AppSettings.UPLOADS_ENDPOINT
  params: any = {
    token: null,
    lang: 'de'
  };
  group: any;
  files: any = [];

  isClosed: boolean = false
  outdatedBrowser: boolean = false
  downloadAttrCompatible: boolean = false

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService,
    private vRef: ViewContainerRef,
    private toastr: ToastsManager,
    private landingpageResource: LandingpageResource
  ) {
      this.toastr.setRootViewContainerRef(vRef);
  }

  ngOnInit() {
    let browserInfo = this.browserCheck()
    if (browserInfo && browserInfo.name && browserInfo.version) {
        this.outdatedBrowser = (browserInfo.name.toLowerCase() == 'ie' || browserInfo.name.toLowerCase() == 'msie')
        this.checkDownloadAttrCompatibility(browserInfo)
    }

    this.route.params.subscribe(params => {
      this.params.token = params['token']

      if (params['lang']) this.params.lang = params['lang']

      this.translate.addLangs(['en', 'de']);
      this.translate.setDefaultLang(this.params.lang);
    });

    if (this.params.token) {
      this.landingpageResource.getContact({token: this.params.token}).$observable
        .subscribe(apiRes => {
          console.log('apiRes:', apiRes);
          this.group = apiRes.group;
          this.files = apiRes.files;
        }, err => {
          if (err.json().code === 498 && err.json().error == 'token') {
            this.toastr.warning("Der Authentifizierungstoken ist abgelaufen", "", {toastLife: 20000});
          } else {
            this.toastr.warning("Kontakt wurde nicht gefunden", "");
          }
        });
    }
  }


  browserCheck () {
      let ua = navigator.userAgent, tem
      let matchInfo = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(matchInfo[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return {name: 'IE', version: (tem[1] || '')};
      }
      if (matchInfo[1] === 'Chrome') {
          tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
          if (tem != null) return {name: tem[1].replace('OPR', 'Opera'), version: tem[2]};
      }
      matchInfo = matchInfo[2] ? [matchInfo[1], matchInfo[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) matchInfo.splice(1, 1, tem[1]);
      return {name: matchInfo[0], version: matchInfo[1]};
  }

  checkDownloadAttrCompatibility (browserInfo) {
    this.downloadAttrCompatible = !(browserInfo.name.toLowerCase() == 'ie' ||
    browserInfo.name.toLowerCase() == 'msie' ||
    (browserInfo.name.toLowerCase() == 'edge' && browserInfo.version < 13) ||
    (browserInfo.name.toLowerCase() == 'firefox' && browserInfo.version < 20) ||
    (browserInfo.name.toLowerCase() == 'chrome' && browserInfo.version < 14) ||
    (browserInfo.name.toLowerCase() == 'safari' && browserInfo.version < 10.1) ||
    (browserInfo.name.toLowerCase() == 'opera' && browserInfo.version < 15));
  }

  changeLanguage() {
    this.translate.use(this.params.lang);
  }

  getLanguageBatch(presentation): any {
    if(
      presentation.languageBatches[this.params.lang].presentationFile
      && presentation.languageBatches[this.params.lang].presentationFile.filename
    ) {
      return presentation.languageBatches[this.params.lang]
    } else if (
      presentation.languageBatches[this.params.lang === 'de' ? 'en' : 'de'].presentationFile
      && presentation.languageBatches[this.params.lang === 'de' ? 'en' : 'de'].presentationFile.filename
    ) {
      return presentation.languageBatches[this.params.lang === 'de' ? 'en' : 'de']
    } else {
      return null
    }
  }

  fileExists(file): boolean {
    return file && file.filename
  }
  filenameFromPath(path) {
    if (!path) return '';
    return path.replace(/^.*[\\\/]/, '');
  }
  basenameFromPath(path) {
    if (!path) return '';
    return path.replace(this.filenameFromPath(path), '');
  }
  baseName(str) {
    let base = new String(str).substring(str.lastIndexOf('/') + 1);
    if(base.lastIndexOf(".") != -1) base = base.substring(0, base.lastIndexOf("."));
    return base;
  }
  isPresentationFile(file) {
    if (file.mimetype === 'application/pdf') return true;
    return false;
  }
  isVideoFile(file) {
    if (file.mimetype === 'video/mp4') return true;
    return false;
  }
  getCachePath(file) {
    return this.basenameFromPath(file.path) + '.qmcache';
  }
  getPreviewImgUri(file) {
    let uri = '';
    // todo: check if cached
    uri += encodeURI(this.getCachePath(file) + '/' + this.filenameFromPath(file.path) + '.jpg');
    // console.log('[Utils] getPreviewImgUri:', uri);
    return uri;
  }
  typeCanHavePreviewImg(file) {
    let canHave = false;
    const types = ['application/pdf', 'video/mp4', 'image/jpeg', 'image/png'].map((type) => {
      if (file.mimetype === type) canHave = true;
    });
    return canHave;
  }






}



// WEBPACK FOOTER //
// ./src/app/landingpage/landingpage.component.ts